/**
 * Host language picker — same codes and ZA flag as legacy-client
 * (UserProfile.vue / Navbar.vue). The shell PRODUCES locale by writing
 * window.MetaShipGlobalState; Boer and every other MFE consume it.
 */
export const LANGUAGE_OPTIONS = [
  { code: "en", label: "English", flag: "https://cdn.metaship.ai/flags/4x3/gb.svg" },
  { code: "af", label: "Afrikaans", flag: "https://cdn.metaship.ai/flags/4x3/za.svg" },
  { code: "es", label: "Español", flag: "https://cdn.metaship.ai/flags/4x3/es.svg" },
  { code: "it", label: "Italiano", flag: "https://cdn.metaship.ai/flags/4x3/it.svg" },
  { code: "ja", label: "日本語", flag: "https://cdn.metaship.ai/flags/4x3/jp.svg" },
] as const;

export type HostLocale = (typeof LANGUAGE_OPTIONS)[number]["code"];

/** legacy-client Vuex setLocale → updateExternalState({ locale }) equivalent. */
export function setHostLocale(code: string): void {
  window.MetaShipGlobalState?.updateState({ locale: code });
}
